// extracted by mini-css-extract-plugin
export var image = "_is-0";